import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "@/utils/axiosInstance";
import { CONTACT_US } from "routes";

const CONTACT_US_URL = "https://api.imagive.ai/api/contact-us";
//contact us thunk
export const postContactUs = createAsyncThunk(
  "contactus/postcontactus",
  async (contactData, { rejectWithValue }) => {
    try {
      const response = await axios.post(CONTACT_US_URL, contactData);
      if (response?.data?.status === true) {
        return response?.data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

const contactUsSlice = createSlice({
  name: "contactUs",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postContactUs.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(postContactUs.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
        state.error = null;
      })
      .addCase(postContactUs.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const {} = contactUsSlice.actions;
export default contactUsSlice.reducer;
